// Sobrescribir window.alert nativo por uno personalizado y moderno que usa los estilos del sistema
(function() {
    window.alert = function(mensaje) {
        const existing = document.getElementById('av-custom-alert-modal');
        if (existing) {
            existing.remove();
        }

        const overlay = document.createElement('div');
        overlay.id = 'av-custom-alert-modal';
        overlay.className = 'modal-overlay';
        overlay.style.zIndex = '999999';

        const content = document.createElement('div');
        content.className = 'modal-content';
        content.style.maxWidth = '400px';
        content.style.textAlign = 'center';

        const h3 = document.createElement('h3');
        h3.textContent = 'Mensaje del Sistema';
        h3.style.marginBottom = '12px';

        const p = document.createElement('p');
        p.textContent = mensaje;
        p.style.fontSize = '0.95rem';
        p.style.lineHeight = '1.45';
        p.style.marginBottom = '20px';
        p.style.whiteSpace = 'pre-wrap';

        const btn = document.createElement('button');
        btn.className = 'btn-primario';
        btn.textContent = 'Aceptar';
        btn.style.margin = '0 auto';
        btn.style.display = 'block';
        btn.style.padding = '8px 24px';
        btn.style.cursor = 'pointer';

        btn.addEventListener('click', function() {
            overlay.remove();
        });

        content.appendChild(h3);
        content.appendChild(p);
        content.appendChild(btn);
        overlay.appendChild(content);
        document.body.appendChild(overlay);
    };

    window.avConfirm = function(mensaje, subtexto = '') {
        return new Promise((resolve) => {
            const existing = document.getElementById('av-custom-confirm-modal');
            if (existing) existing.remove();

            const overlay = document.createElement('div');
            overlay.id = 'av-custom-confirm-modal';
            overlay.className = 'modal-overlay';
            overlay.style.zIndex = '999999';

            const content = document.createElement('div');
            content.className = 'modal-content';
            content.style.maxWidth = '420px';
            content.style.textAlign = 'center';

            const h3 = document.createElement('h3');
            h3.textContent = 'Confirmar Acción';
            h3.style.marginBottom = '12px';
            h3.style.color = 'var(--av-heading)';

            const p = document.createElement('p');
            p.textContent = mensaje;
            p.style.fontSize = '1rem';
            p.style.lineHeight = '1.5';
            p.style.marginBottom = subtexto ? '8px' : '24px';
            p.style.color = 'var(--av-text)';
            p.style.whiteSpace = 'pre-wrap';

            content.appendChild(h3);
            content.appendChild(p);

            if (subtexto) {
                const subP = document.createElement('p');
                subP.textContent = subtexto;
                subP.style.fontSize = '0.85rem';
                subP.style.color = 'var(--av-text-muted)';
                subP.style.marginBottom = '24px';
                subP.style.whiteSpace = 'pre-wrap';
                content.appendChild(subP);
            }

            const actions = document.createElement('div');
            actions.className = 'modal-actions';
            actions.style.justifyContent = 'center';

            const btnCancel = document.createElement('button');
            btnCancel.className = 'btn-cancelar';
            btnCancel.textContent = 'Cancelar';
            btnCancel.type = 'button';
            
            const btnOk = document.createElement('button');
            btnOk.className = 'btn-primario';
            btnOk.textContent = 'Aceptar';
            btnOk.type = 'button';

            btnCancel.addEventListener('click', () => {
                overlay.remove();
                resolve(false);
            });

            btnOk.addEventListener('click', () => {
                overlay.remove();
                resolve(true);
            });

            actions.appendChild(btnCancel);
            actions.appendChild(btnOk);
            content.appendChild(actions);
            overlay.appendChild(content);
            document.body.appendChild(overlay);
        });
    };
})();

// Variable global para rastrear la celda actual
let celdaReferencia = null;

let profesoresData = [];

/**
 * Abre el modal y prepara los datos para la asignación
 */
async function abrirModalAsignacion(dia, hora) {
    celdaReferencia = { dia, hora };

    const celdaActual = document.querySelector(`td[data-dia="${dia}"][data-hora="${hora}"]`);
    if (!celdaActual) {
        console.error('No se encontró la celda para', dia, hora);
        return;
    }

    // 1. Llenar campos ocultos del formulario
    document.getElementById('inputDia').value = dia;
    document.getElementById('inputHora').value = hora;
    document.getElementById('modalTitulo').innerText = `${dia} - ${hora}`;

    // 2. Referencia a elementos del modal
    const selectMateria = document.getElementById('selectMateria');
    const selectProfesor = document.getElementById('selectProfesor');
    const selectPC = document.getElementById('selectPC');
    const selectBeam = document.getElementById('selectBeam');
    const inputUsoPc = document.getElementById('inputUsoPc');
    const inputUsoBeam = document.getElementById('inputUsoBeam');

    const pcVal = celdaActual.dataset.pc || "0";
    const beamVal = celdaActual.dataset.beam || "0";

    // Admin usa hidden inputs (solo lectura); técnico usa selects para cambiar PC/Beam
    if (selectPC && selectBeam) {
        selectPC.value = pcVal;
        selectBeam.value = beamVal;
    }
    if (inputUsoPc && inputUsoBeam) {
        inputUsoPc.value = pcVal;
        inputUsoBeam.value = beamVal;
    }

    // 4. Controlar visibilidad del botón "Extender"
    const btnExtender = document.getElementById('btnExtender');
    if (btnExtender) btnExtender.style.display = (hora.startsWith('08:00')) ? 'none' : 'block';

    // 5. Cargar lista de profesores desde la API (solo si el select está vacío)
    if (selectProfesor && selectProfesor.options.length <= 1) {
        try {
            const resp = await fetch('api/get_profesores.php');
            const profesores = await resp.json();
            if (Array.isArray(profesores)) {
                profesoresData = profesores;
                profesores.forEach(prof => {
                    const opt = document.createElement('option');
                    opt.value = prof.id;
                    opt.text = prof.nombre;
                    selectProfesor.add(opt);
                });
            }
        } catch (error) {
            console.error("Error cargando profesores:", error);
        }
    }

    if (selectProfesor) {
        selectProfesor.onchange = (e) => poblarSelectMaterias(e.target.value);
    }

    // 3. Si la celda ya tiene datos (EDICIÓN), cargarlos. Si no, RESETEAR a valores por defecto.
    if (celdaActual.dataset.profesorId) {
        selectProfesor.value = celdaActual.dataset.profesorId;
        poblarSelectMaterias(celdaActual.dataset.profesorId, celdaActual.dataset.materia || '');
    } else {
        selectProfesor.value = "";
        if (selectMateria) {
            selectMateria.innerHTML = '<option value="">Seleccione un profesor primero</option>';
            selectMateria.disabled = true;
        }
    }

    // 6. Mostrar el modal (flex para centrado según estilos del proyecto)
    const modal = document.getElementById('modalAsignacion');
    if (modal) modal.style.display = 'flex';
}

function poblarSelectMaterias(profesorId, materiaPreseleccionada = '') {
    const selectMateria = document.getElementById('selectMateria');
    if (!selectMateria) return;
    selectMateria.innerHTML = '<option value="">Seleccione una materia</option>';
    if (!profesorId) {
        selectMateria.disabled = true;
        return;
    }
    selectMateria.disabled = false;
    const prof = profesoresData.find(p => p.id == profesorId);
    let materias = [];
    if (prof && prof.materias) {
        try { materias = JSON.parse(prof.materias); } catch(e) {}
    }
    
    if (materias.length === 0) {
        selectMateria.innerHTML = '<option value="">Profesor sin materias registradas</option>';
    } else {
        materias.forEach(m => {
            const opt = document.createElement('option');
            opt.value = m;
            opt.text = m;
            if (m === materiaPreseleccionada) opt.selected = true;
            selectMateria.add(opt);
        });
    }
    if (materiaPreseleccionada && !materias.includes(materiaPreseleccionada)) {
        const opt = document.createElement('option');
        opt.value = materiaPreseleccionada;
        opt.text = materiaPreseleccionada + ' (Anterior)';
        opt.selected = true;
        selectMateria.add(opt);
    }
}

/**
 * Cierra el modal y limpia el formulario
 */
function cerrarModal() {
    document.getElementById('modalAsignacion').style.display = 'none';
    document.getElementById('formAsignacion').reset();
}

/**
 * Lógica para copiar los datos del bloque de tiempo inmediatamente anterior
 */
function extenderAnterior() {
    const { dia, hora } = celdaReferencia;
    
    // Obtenemos todas las celdas de ese día (columna)
    const celdasDia = Array.from(document.querySelectorAll(`td[data-dia="${dia}"]`));
    
    // Buscamos el índice de la hora actual
    const idxActual = celdasDia.findIndex(td => td.dataset.hora === hora);

    if (idxActual > 0) {
        const celdaAnterior = celdasDia[idxActual - 1];
        const profId = celdaAnterior.dataset.profesorId;
        const materia = celdaAnterior.dataset.materia;

        if (profId && materia) {
            document.getElementById('selectProfesor').value = profId;
            poblarSelectMaterias(profId, materia);
        } else {
            alert("El bloque anterior está vacío.");
        }
    }
}

/**
 * Manejo del envío del formulario vía AJAX
 */
document.getElementById('formAsignacion')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
        const resp = await fetch('api/guardar_horario.php', {
            method: 'POST',
            body: formData
        });
        const resultado = await resp.json();

        if (resultado.success) {
            // Recarga rápida para visualizar los cambios
            location.reload(); 
        } else {
            alert("Error al guardar: " + resultado.error);
        }
    } catch (error) {
        console.error("Error en la petición:", error);
    }
});

// --- Lógica de Gestión de Usuarios ---

/** Escapa texto para insertar en HTML (evita romper filas/columnas de la tabla). */
function escapeHtmlUsuarios(text) {
    if (text === null || text === undefined) {
        return '';
    }
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

const escapeHtml = escapeHtmlUsuarios;

function generarInputsMaterias(containerId, count, valoresPredefinidos = []) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = '';
    for (let i = 0; i < count; i++) {
        const input = document.createElement('input');
        input.type = 'text';
        input.name = 'materias[]';
        input.placeholder = `Nombre de la materia ${i + 1}`;
        input.required = true;
        input.value = valoresPredefinidos[i] || '';
        input.style.width = '100%';
        input.style.padding = '8px';
        container.appendChild(input);
    }
}

const USUARIOS_PAGE_SIZE = 10;
const usuariosState = {
    all: [],
    page: 1,
    search: '',
    campo: 'todos',
    rol: '',
};

function initUsuarios() {
    const tablaUsuarios = document.getElementById('listaUsuarios');
    if (!tablaUsuarios) return;

    cargarUsuarios();

    document.getElementById('formCrearUsuario')?.addEventListener('submit', enviarFormularioUsuario);
    document.getElementById('formEditarUsuario')?.addEventListener('submit', enviarFormularioUsuario);
    document.getElementById('formEliminarUsuario')?.addEventListener('submit', enviarFormularioUsuario);

    const buscar = document.getElementById('usuariosBuscar');
    const filtroCampo = document.getElementById('usuariosFiltroCampo');
    const filtroRol = document.getElementById('usuariosFiltroRol');
    const pagAnterior = document.getElementById('usuariosPagAnterior');
    const pagSiguiente = document.getElementById('usuariosPagSiguiente');

    const onFiltroChange = () => {
        usuariosState.search = (buscar?.value || '').trim().toLowerCase();
        usuariosState.campo = filtroCampo?.value || 'todos';
        usuariosState.rol = filtroRol?.value || '';
        usuariosState.page = 1;
        renderUsuariosFiltrados();
    };

    buscar?.addEventListener('input', onFiltroChange);
    filtroCampo?.addEventListener('change', onFiltroChange);
    filtroRol?.addEventListener('change', onFiltroChange);

    pagAnterior?.addEventListener('click', () => {
        if (usuariosState.page > 1) {
            usuariosState.page -= 1;
            renderUsuariosFiltrados();
        }
    });

    pagSiguiente?.addEventListener('click', () => {
        const totalPages = getUsuariosTotalPages();
        if (usuariosState.page < totalPages) {
            usuariosState.page += 1;
            renderUsuariosFiltrados();
        }
    });

    const crearRol = document.getElementById('crearRol');
    const contenedorMateriasCrear = document.getElementById('contenedorMateriasCrear');
    const cantidadMateriasCrear = document.getElementById('cantidadMateriasCrear');

    if (crearRol) {
        crearRol.addEventListener('change', (e) => {
            contenedorMateriasCrear.style.display = e.target.value === 'profesor' ? 'block' : 'none';
            if (e.target.value === 'profesor' && document.getElementById('inputsMateriasCrear').children.length === 0) {
                generarInputsMaterias('inputsMateriasCrear', parseInt(cantidadMateriasCrear.value));
            }
        });
    }
    if (cantidadMateriasCrear) {
        cantidadMateriasCrear.addEventListener('change', (e) => {
            generarInputsMaterias('inputsMateriasCrear', parseInt(e.target.value));
        });
    }

    const editRol = document.getElementById('editRol');
    const contenedorMateriasEditar = document.getElementById('contenedorMateriasEditar');
    const cantidadMateriasEditar = document.getElementById('cantidadMateriasEditar');

    if (editRol) {
        editRol.addEventListener('change', (e) => {
            contenedorMateriasEditar.style.display = e.target.value === 'profesor' ? 'block' : 'none';
            if (e.target.value === 'profesor' && document.getElementById('inputsMateriasEditar').children.length === 0) {
                generarInputsMaterias('inputsMateriasEditar', parseInt(cantidadMateriasEditar.value));
            }
        });
    }
    if (cantidadMateriasEditar) {
        cantidadMateriasEditar.addEventListener('change', (e) => {
            generarInputsMaterias('inputsMateriasEditar', parseInt(e.target.value));
        });
    }
}

function getUsuariosFiltrados() {
    return usuariosState.all.filter(usuarioMatchesFilter);
}

function getUsuariosTotalPages() {
    const total = getUsuariosFiltrados().length;
    return Math.max(1, Math.ceil(total / USUARIOS_PAGE_SIZE));
}

function usuarioMatchesFilter(u) {
    if (usuariosState.rol && u.rol !== usuariosState.rol) {
        return false;
    }

    const term = usuariosState.search;
    if (!term) {
        return true;
    }

    const campos = {
        cedula: u.cedula,
        nombre: u.nombre,
        usuario: u.usuario,
        rol: u.rol,
        email: u.email,
        phone: u.phone,
        pin: u.pin,
        nfc_id: u.nfc_id,
        huella_id: u.huella_id,
    };

    const campo = usuariosState.campo;
    if (campo === 'todos') {
        return Object.values(campos).some(val => val != null && String(val).toLowerCase().includes(term));
    }

    const valor = campos[campo];
    return valor != null && String(valor).toLowerCase().includes(term);
}

function buildUsuarioRowHtml(u) {
    const esUsuarioActual = typeof USUARIO_ACTUAL_ID !== 'undefined' && USUARIO_ACTUAL_ID !== null && parseInt(USUARIO_ACTUAL_ID, 10) === parseInt(u.id, 10);
    const botonEliminar = esUsuarioActual
        ? '<span style="color: #999; font-size: 0.9em;">No disponible</span>'
        : `<button type="button" class="btn-icon btn-delete" onclick="abrirEliminarUsuario(${parseInt(u.id, 10)})">🗑️</button>`;

    const pinRaw = u.pin !== null && u.pin !== undefined && String(u.pin) !== '' ? String(u.pin) : '';
    const nfcRaw = u.nfc_id !== null && u.nfc_id !== undefined && String(u.nfc_id) !== '' ? String(u.nfc_id) : '';
    const huellaRaw = u.huella_id !== null && u.huella_id !== undefined && String(u.huella_id) !== '' ? String(u.huella_id) : '';
    const pinTxt = pinRaw === '' ? '—' : escapeHtmlUsuarios(pinRaw);
    const nfcTxt = nfcRaw === '' ? '—' : escapeHtmlUsuarios(nfcRaw);
    const huellaTxt = huellaRaw === '' ? '—' : escapeHtmlUsuarios(huellaRaw);
    const cedulaTxt = escapeHtmlUsuarios(u.cedula != null && String(u.cedula) !== '' ? String(u.cedula) : 'N/A');
    const nombreTxt = escapeHtmlUsuarios(u.nombre || '');
    const usuarioTxt = escapeHtmlUsuarios(u.usuario || '');
    const rolSeguro = ['administrador', 'tecnico', 'profesor'].includes(u.rol) ? u.rol : '';
    const rolLabel = rolSeguro === '' ? 'N/A' : escapeHtmlUsuarios(rolSeguro);
    const estadoRaw = u.estado || 'normal';
    const estadoTxt = estadoRaw === 'bloqueado' ? 'Bloqueado' : 'Normal';
    const estadoBadge = `<span class="badge-estado ${escapeHtmlUsuarios(estadoRaw)}">${escapeHtmlUsuarios(estadoTxt)}</span>`;
    const uid = parseInt(u.id, 10);

    return `
        <tr>
            <td>${cedulaTxt}</td>
            <td>${nombreTxt}</td>
            <td>${usuarioTxt}</td>
            <td><span class="badge-rol ${rolSeguro}">${rolLabel}</span></td>
            <td>${pinTxt}</td>
            <td style="font-size:0.85rem;max-width:140px;overflow:hidden;text-overflow:ellipsis;" title="${nfcRaw === '' ? '' : escapeHtmlUsuarios(nfcRaw)}">${nfcTxt}</td>
            <td>${huellaTxt}</td>
            <td>${estadoBadge}</td>
            <td class="acciones">
                <button type="button" class="btn-icon" onclick="abrirEditarUsuarioDesdeId(${uid})">✏️</button>
                ${botonEliminar}
            </td>
        </tr>
    `;
}

function renderUsuariosFiltrados() {
    const tabla = document.getElementById('listaUsuarios');
    if (!tabla) return;

    const filtrados = getUsuariosFiltrados();
    const totalPages = getUsuariosTotalPages();
    if (usuariosState.page > totalPages) {
        usuariosState.page = totalPages;
    }

    const info = document.getElementById('usuariosResultadosInfo');
    const pagInfo = document.getElementById('usuariosPagInfo');
    const pagAnterior = document.getElementById('usuariosPagAnterior');
    const pagSiguiente = document.getElementById('usuariosPagSiguiente');

    if (usuariosState.all.length === 0) {
        tabla.innerHTML = '<tr><td colspan="9" style="text-align: center; padding: 20px;">No hay usuarios registrados</td></tr>';
        if (info) info.textContent = '';
        if (pagInfo) pagInfo.textContent = 'Página 1 de 1';
        if (pagAnterior) pagAnterior.disabled = true;
        if (pagSiguiente) pagSiguiente.disabled = true;
        return;
    }

    if (filtrados.length === 0) {
        tabla.innerHTML = '<tr><td colspan="9" style="text-align: center; padding: 20px;">No hay usuarios que coincidan con la búsqueda.</td></tr>';
        if (info) info.textContent = `0 de ${usuariosState.all.length} usuarios`;
        if (pagInfo) pagInfo.textContent = 'Página 1 de 1';
        if (pagAnterior) pagAnterior.disabled = true;
        if (pagSiguiente) pagSiguiente.disabled = true;
        return;
    }

    const start = (usuariosState.page - 1) * USUARIOS_PAGE_SIZE;
    const pageItems = filtrados.slice(start, start + USUARIOS_PAGE_SIZE);
    tabla.innerHTML = pageItems.map(buildUsuarioRowHtml).join('');

    const desde = start + 1;
    const hasta = start + pageItems.length;
    if (info) {
        info.textContent = `Mostrando ${desde}–${hasta} de ${filtrados.length} (${usuariosState.all.length} en total)`;
    }
    if (pagInfo) {
        pagInfo.textContent = `Página ${usuariosState.page} de ${totalPages}`;
    }
    if (pagAnterior) {
        pagAnterior.disabled = usuariosState.page <= 1;
    }
    if (pagSiguiente) {
        pagSiguiente.disabled = usuariosState.page >= totalPages;
    }
}

async function cargarUsuarios() {
    try {
        const res = await fetch('api/gestion_usuarios.php');
        
        // Verificar que la respuesta sea exitosa
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        
        const data = await res.json();
        
        // Si la respuesta es un objeto con success: false, mostrar el error
        if (data && typeof data === 'object' && data.success === false) {
            const errorMsg = data.error || 'Error desconocido';
            console.error("Error del API:", errorMsg);
            const tabla = document.getElementById('listaUsuarios');
            if (tabla) {
                tabla.innerHTML = `<tr><td colspan="9" style="text-align: center; padding: 20px; color: red;">Error: ${errorMsg}</td></tr>`;
            }
            return;
        }
        
        // Validar que la respuesta sea un array
        if (!Array.isArray(data)) {
            console.error("La respuesta no es un array:", data);
            const tabla = document.getElementById('listaUsuarios');
            if (tabla) {
                tabla.innerHTML = '<tr><td colspan="9" style="text-align: center; padding: 20px; color: red;">Error: Formato de respuesta inválido del servidor.</td></tr>';
            }
            return;
        }
        
        const tabla = document.getElementById('listaUsuarios');
        if (!tabla) {
            console.error("No se encontró el elemento listaUsuarios");
            return;
        }

        window._usuariosListaCache = {};
        data.forEach((u) => {
            window._usuariosListaCache[u.id] = u;
        });

        usuariosState.all = data;
        usuariosState.page = 1;
        renderUsuariosFiltrados();
    } catch (error) {
        console.error("Error al cargar usuarios:", error);
        const tabla = document.getElementById('listaUsuarios');
        if (tabla) {
            tabla.innerHTML = '<tr><td colspan="9" style="text-align: center; padding: 20px; color: red;">Error al cargar usuarios. Ver consola para más detalles.</td></tr>';
        }
    }
}

async function enviarFormularioUsuario(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    try {
        const res = await fetch('api/gestion_usuarios.php', { method: 'POST', body: formData });
        const data = await res.json();
        
        if (data.success) {
            cerrarModales();
            cargarUsuarios();
            e.target.reset();
        } else {
            alert("Error: " + data.error);
        }
    } catch (error) {
        console.error("Error en la petición:", error);
    }
}

window.abrirEditarUsuarioDesdeId = (id) => {
    const u = window._usuariosListaCache && window._usuariosListaCache[id];
    if (!u) {
        return;
    }
    window.abrirEditarUsuario(u);
};

// Funciones globales para los botones (necesitan estar en el scope global o Window)
window.abrirEditarUsuario = (u) => {
    document.getElementById('editId').value = u.id || '';
    document.getElementById('editNombre').value = u.nombre || '';
    document.getElementById('editCedula').value = u.cedula || '';
    document.getElementById('editUsuario').value = u.usuario || '';
    document.getElementById('editEmail').value = u.email || '';
    document.getElementById('editPhone').value = u.phone || '';
    const rolSeguro = u.rol || '';
    document.getElementById('editRol').value = rolSeguro;

    // Lógica para llenar materias dinámicamente si es profesor
    if (rolSeguro === 'profesor') {
        document.getElementById('contenedorMateriasEditar').style.display = 'block';
        let materiasArr = [];
        try {
            if (u.materias) {
                materiasArr = JSON.parse(u.materias);
            }
        } catch(e) {}
        
        const count = Math.max(1, Math.min(5, materiasArr.length || 1));
        document.getElementById('cantidadMateriasEditar').value = count;
        generarInputsMaterias('inputsMateriasEditar', count, materiasArr);
    } else {
        document.getElementById('contenedorMateriasEditar').style.display = 'none';
        document.getElementById('inputsMateriasEditar').innerHTML = '';
    }

    document.getElementById('editPin').value =
        u.pin !== null && u.pin !== undefined && String(u.pin) !== '' ? String(u.pin) : '';
    document.getElementById('editNfcId').value =
        u.nfc_id !== null && u.nfc_id !== undefined && String(u.nfc_id) !== '' ? String(u.nfc_id) : '';
    document.getElementById('editHuellaId').value =
        u.huella_id !== null && u.huella_id !== undefined && String(u.huella_id) !== ''
            ? String(u.huella_id)
            : '';
    const pw = document.getElementById('editPassword');
    if (pw) {
        pw.value = '';
    }
    const editEstado = document.getElementById('editEstado');
    if (editEstado) {
        editEstado.value = u.estado || 'normal';
    }
    document.getElementById('modalEditar').style.display = 'flex';
};

window.abrirEliminarUsuario = (id) => {
    document.getElementById('deleteId').value = id;
    document.getElementById('modalEliminar').style.display = 'flex';
};

window.cerrarModales = () => {
    document.getElementById('modalEditar').style.display = 'none';
    document.getElementById('modalEliminar').style.display = 'none';
};

// --- Mantenimientos ---

async function fetchBloquesActivos() {
    try {
        const res = await fetch('/api/get_bloques.php');
        const data = await res.json();
        return Array.isArray(data.bloques) ? data.bloques : [];
    } catch (e) {
        return [];
    }
}

function initMantenimiento() {
    const lista = document.getElementById('listaMantenimientos');
    if (!lista) return;

    cargarMantenimientos();

    document.getElementById('formCrearMantenimiento')?.addEventListener('submit', enviarFormularioMantenimiento);
    document.getElementById('formEditarMantenimiento')?.addEventListener('submit', enviarFormularioMantenimiento);
    document.getElementById('formEliminarMantenimiento')?.addEventListener('submit', enviarFormularioMantenimiento);
    document.getElementById('formEnviarNotificacion')?.addEventListener('submit', enviarNotificacionMantenimiento);
    document.getElementById('formDiferirMantenimiento')?.addEventListener('submit', enviarFormularioMantenimiento);

    const selectBloque = document.getElementById('selectBloque');
    if (selectBloque) {
        selectBloque.addEventListener('change', function () {
            const bloque = this.value;
            const selectSalon = document.getElementById('selectSalon');
            if (!bloque) {
                selectSalon.innerHTML = '<option value="">Primero elija un bloque</option>';
                selectSalon.disabled = true;
                return;
            }
            loadSalonesByBloque(bloque, selectSalon, null);
            selectSalon.disabled = false;
        });
    }

    const editBloque = document.getElementById('editBloque');
    if (editBloque) {
        fetchBloquesActivos().then(bloques => {
            editBloque.innerHTML = '<option value="">Seleccione...</option>' + bloques.map(b => `<option value="${escapeHtml(b)}">${escapeHtml(b)}</option>`).join('');
        });
        editBloque.addEventListener('change', function () {
            loadSalonesByBloque(this.value, document.getElementById('editSalonId'), null);
        });
    }
}

async function loadSalonesByBloque(bloque, selectEl, selectedId) {
    if (!selectEl || !bloque) return;
    try {
        const res = await fetch(`api/get_salones.php?bloque=${encodeURIComponent(bloque)}`);
        const salones = await res.json();
        selectEl.innerHTML = '<option value="">Seleccione salón...</option>';
        if (Array.isArray(salones)) {
            salones.forEach(s => {
                const opt = document.createElement('option');
                opt.value = s.id;
                opt.textContent = `Salón ${bloque}-${s.numero_salon}`;
                if (selectedId && s.id == selectedId) opt.selected = true;
                selectEl.appendChild(opt);
            });
        }
    } catch (e) {
        console.error('Error cargando salones:', e);
    }
}

function etiquetaEstadoMantenimiento(codigo) {
    const c = codigo ? String(codigo) : 'programado';
    const map = {
        programado: 'Programado',
        en_proceso: 'En proceso',
        diferido: 'Diferido / en pausa',
        completado: 'Completado',
    };
    return map[c] || c;
}

function claseEstadoInventarioMant(estado) {
    const map = {
        disponible: 'inv-estado--disponible',
        en_reparacion: 'inv-estado--reparacion',
        no_disponible: 'inv-estado--no-disponible',
    };
    return map[String(estado || 'disponible')] || 'inv-estado--disponible';
}

function celdaRecursosMantenimientoHtml(m) {
    const lineas = [];
    if (parseInt(m.recurso_pc, 10) === 1) {
        const et = m.pc_estado_etiqueta || m.pc_estado_actual || '—';
        lineas.push(
            `<div class="mant-recurso-linea"><span class="mant-recurso-tag">PC</span>` +
            `<span class="inv-estado ${claseEstadoInventarioMant(m.pc_estado_actual)}">${escapeHtmlUsuarios(String(et))}</span></div>`
        );
    }
    if (parseInt(m.recurso_beam, 10) === 1) {
        const et = m.beam_estado_etiqueta || m.beam_estado_actual || '—';
        lineas.push(
            `<div class="mant-recurso-linea"><span class="mant-recurso-tag">BEAM</span>` +
            `<span class="inv-estado ${claseEstadoInventarioMant(m.beam_estado_actual)}">${escapeHtmlUsuarios(String(et))}</span></div>`
        );
    }
    if (lineas.length === 0) {
        return '<span class="texto-secundario">—</span>';
    }
    return `<div class="mant-recursos-celda">${lineas.join('')}</div>`;
}

async function ejecutarEstadoMantenimiento(id, accion) {
    const fd = new FormData();
    fd.append('accion', accion);
    fd.append('id', String(id));
    try {
        const res = await fetch('api/gestion_mantenimientos.php', { method: 'POST', body: fd });
        const data = await res.json();
        if (!data.success) {
            alert('Error: ' + (data.error || 'Sin detalle'));
            return;
        }
        cargarMantenimientos();
    } catch (e) {
        console.error(e);
        alert('Error de conexión');
    }
}

window.mantenimientoMarcarAsistencia = (id) => ejecutarEstadoMantenimiento(id, 'marcar_en_proceso');
window.mantenimientoMarcarCompletado = (id) => ejecutarEstadoMantenimiento(id, 'marcar_completado');
window.mantenimientoMarcarDiferido = (id) => {
    document.getElementById('diferirMantId').value = id;
    document.getElementById('diferirMotivo').value = '';
    document.getElementById('modalDiferirMantenimiento').style.display = 'flex';
};

async function cargarMantenimientos() {
    const tbody = document.getElementById('listaMantenimientos');
    if (!tbody) return;
    const esAdmin = document.body.dataset.esAdmin === '1';
    const colSpanErrores = 9;
    try {
        const res = await fetch('api/gestion_mantenimientos.php');
        if (!res.ok) throw new Error('Error al cargar');
        const data = await res.json();
        if (data && typeof data === 'object' && data.success === false) {
            tbody.innerHTML = `<tr><td colspan="${colSpanErrores}" style="text-align:center;color:red;">${data.error || 'Error'}</td></tr>`;
            return;
        }
        if (!Array.isArray(data)) {
            tbody.innerHTML = `<tr><td colspan="${colSpanErrores}" style="text-align:center;">No hay datos</td></tr>`;
            return;
        }
        if (data.length === 0) {
            tbody.innerHTML = `<tr><td colspan="${colSpanErrores}" style="text-align:center;padding:20px;">No hay mantenimientos programados.</td></tr>`;
            return;
        }
        tbody.innerHTML = '';
        data.forEach(m => {
            const json = JSON.stringify(m).replace(/'/g, "&apos;");
            const inicio = formatearFechaHora(m.fecha_inicio);
            const fin = formatearFechaHora(m.fecha_fin);
            const est = String(m.estado || 'programado');
            const btnAsistencia = (est === 'programado' || est === 'diferido')
                ? `<button type="button" class="btn-icon" onclick="mantenimientoMarcarAsistencia(${m.id})" title="${est === 'diferido' ? 'Reanudar (en proceso)' : 'Marcar asistencia (en proceso)'}">${est === 'diferido' ? '▶️' : '🛠️'}</button>`
                : '';
            const btnDiferido = est === 'en_proceso'
                ? `<button type="button" class="btn-icon" onclick="mantenimientoMarcarDiferido(${m.id})" title="Diferir / pausar">⏸️</button>`
                : '';
            const motivoDif = est === 'diferido' && m.motivo_diferido
                ? `<br><small style="color:#64748b;font-weight:normal;" title="${String(m.motivo_diferido).replace(/"/g, '&quot;')}">Motivo: ${String(m.motivo_diferido).slice(0, 60)}${String(m.motivo_diferido).length > 60 ? '…' : ''}</small>`
                : '';
            const btnHecho = est === 'en_proceso'
                ? `<button type="button" class="btn-icon" onclick="mantenimientoMarcarCompletado(${m.id})" title="Marcar completado">✅</button>`
                : '';
            const accionesAdmin = esAdmin
                ? `
                        <button type="button" class="btn-icon" onclick='abrirEditarMantenimiento(${json})' title="Editar">✏️</button>
                        <button type="button" class="btn-icon btn-delete" onclick='abrirEliminarMantenimiento(${m.id})' title="Eliminar">🗑️</button>
                        <button type="button" class="btn-icon btn-notificar" onclick="abrirModalNotificacionMantenimiento(${m.id})" title="Enviar notificación">📢</button>`
                : '';
            tbody.innerHTML += `
                <tr>
                    <td>${m.bloque || ''}</td>
                    <td>${m.numero_salon ?? ''}</td>
                    <td>${inicio}</td>
                    <td>${fin}</td>
                    <td>${m.descripcion || '-'}</td>
                    <td>${m.tecnico_nombre || '<span class="texto-secundario">General</span>'}</td>
                    <td>${celdaRecursosMantenimientoHtml(m)}</td>
                    <td>${etiquetaEstadoMantenimiento(est)}${motivoDif}</td>
                    <td class="acciones">
                        ${accionesAdmin}
                        ${btnAsistencia}
                        ${btnDiferido}
                        ${btnHecho}
                    </td>
                </tr>
            `;
        });
    } catch (e) {
        console.error('Error al cargar mantenimientos:', e);
        tbody.innerHTML = `<tr><td colspan="${colSpanErrores}" style="text-align:center;color:red;">Error al cargar. Ver consola.</td></tr>`;
    }
}

function formatearFechaHora(str) {
    if (!str) return '-';
    try {
        const d = new Date(str);
        if (isNaN(d.getTime())) return str;
        return d.toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' });
    } catch (_) {
        return str;
    }
}

async function enviarFormularioMantenimiento(e) {
    e.preventDefault();
    const form = e.target;
    const accion = form.querySelector('[name="accion"]')?.value;
    const formData = new FormData(form);
    if (accion === 'crear') {
        formData.delete('bloque');
    }
    if (accion === 'editar') {
        formData.delete('bloque');
    }
    try {
        const res = await fetch('api/gestion_mantenimientos.php', { method: 'POST', body: formData });
        const data = await res.json();
        if (data.success) {
            cerrarModalesMantenimiento();
            cargarMantenimientos();
            if (form.id === 'formCrearMantenimiento') {
                form.reset();
                const chkPc = document.getElementById('crearRecursoPc');
                const chkBeam = document.getElementById('crearRecursoBeam');
                if (chkPc) chkPc.checked = false;
                if (chkBeam) chkBeam.checked = false;
            }
            const selectSal = document.getElementById('selectSalon');
            if (selectSal) {
                selectSal.disabled = true;
                selectSal.innerHTML = '<option value="">Primero elija un bloque</option>';
            }
        } else {
            alert('Error: ' + (data.error || 'Desconocido'));
        }
    } catch (err) {
        console.error(err);
        alert('Error de conexión');
    }
}

window.abrirEditarMantenimiento = async function (m) {
    document.getElementById('editMantId').value = m.id;
    const toDatetimeLocal = (s) => (s || '').replace(' ', 'T').slice(0, 16);
    document.getElementById('editFechaInicio').value = toDatetimeLocal(m.fecha_inicio);
    document.getElementById('editFechaFin').value = toDatetimeLocal(m.fecha_fin);
    document.getElementById('editDescripcion').value = m.descripcion || '';
    document.getElementById('editRecursoPc').checked = parseInt(m.recurso_pc, 10) === 1;
    document.getElementById('editRecursoBeam').checked = parseInt(m.recurso_beam, 10) === 1;
    
    const selTecnico = document.getElementById('editTecnicoUsuarioId');
    if (selTecnico) {
        selTecnico.value = m.tecnico_usuario_id || '';
    }
    
    document.getElementById('editBloque').value = m.bloque || '';
    const editSalon = document.getElementById('editSalonId');
    await loadSalonesByBloque(m.bloque, editSalon, m.salon_id);
    document.getElementById('modalEditarMantenimiento').style.display = 'flex';
};

window.abrirEliminarMantenimiento = function (id) {
    document.getElementById('deleteMantId').value = id;
    document.getElementById('modalEliminarMantenimiento').style.display = 'flex';
};

window.cerrarModalesMantenimiento = function () {
    document.getElementById('modalEditarMantenimiento').style.display = 'none';
    document.getElementById('modalEliminarMantenimiento').style.display = 'none';
    const modalNotif = document.getElementById('modalEnviarNotificacion');
    if (modalNotif) modalNotif.style.display = 'none';
    const modalDif = document.getElementById('modalDiferirMantenimiento');
    if (modalDif) modalDif.style.display = 'none';
};

window.abrirModalNotificacionMantenimiento = function (id) {
    document.getElementById('notifMantId').value = id;
    document.getElementById('selectAlcanceNotif').value = 'todos';
    document.getElementById('modalEnviarNotificacion').style.display = 'flex';
};

async function enviarNotificacionMantenimiento(e) {
    e.preventDefault();
    const form = document.getElementById('formEnviarNotificacion');
    if (!form) return;
    const formData = new FormData(form);
    try {
        const res = await fetch('api/gestion_mantenimientos.php', { method: 'POST', body: formData });
        const text = await res.text();
        let data;
        try {
            data = JSON.parse(text);
        } catch (_) {
            console.error('Respuesta no JSON:', text);
            alert('Error del servidor. Revisa la consola (F12).');
            return;
        }
        if (data.success) {
            cerrarModalesMantenimiento();
            alert('Notificación enviada a los usuarios del alcance seleccionado.');
        } else {
            alert('Error: ' + (data.error || 'No se pudo enviar'));
        }
    } catch (err) {
        console.error(err);
        alert('Error de conexión.');
    }
}

// --- Menú móvil (hamburguesa): drawer lateral izquierdo, alternar visible/oculto ---
// En algunos móviles se disparan touchend + click; si respondemos a ambos, el menú se abre y se cierra al instante.
// Usamos un guard para ignorar el click sintético que llega tras un touchend (solo contar una acción por gesto).
function initSidebarMobile() {
    var lastTouchEnd = 0;
    var GESTURE_MS = 400;

    function openSidebar() {
        document.body.classList.add('sidebar-open');
        var btn = document.getElementById('btn-menu-mobile');
        var overlay = document.getElementById('sidebar-overlay');
        if (btn) { btn.setAttribute('aria-label', 'Cerrar menú'); btn.setAttribute('aria-expanded', 'true'); }
        if (overlay) overlay.setAttribute('aria-hidden', 'false');
    }
    function closeSidebar() {
        document.body.classList.remove('sidebar-open');
        var btn = document.getElementById('btn-menu-mobile');
        var overlay = document.getElementById('sidebar-overlay');
        if (btn) { btn.setAttribute('aria-label', 'Abrir menú'); btn.setAttribute('aria-expanded', 'false'); }
        if (overlay) overlay.setAttribute('aria-hidden', 'true');
    }
    function toggleSidebar() {
        if (document.body.classList.contains('sidebar-open')) {
            closeSidebar();
        } else {
            openSidebar();
        }
    }

    function onHamburgerTap(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleSidebar();
    }

    function onHamburgerClick(e) {
        if (Date.now() - lastTouchEnd < GESTURE_MS) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        toggleSidebar();
    }

    var btn = document.getElementById('btn-menu-mobile');
    if (btn) {
        btn.addEventListener('touchend', function (e) {
            lastTouchEnd = Date.now();
            onHamburgerTap(e);
        }, { passive: false });
        btn.addEventListener('click', onHamburgerClick);
    }

    var overlay = document.getElementById('sidebar-overlay');
    var closeBtn = document.getElementById('sidebar-close');
    if (overlay) {
        overlay.addEventListener('click', closeSidebar);
        overlay.addEventListener('touchend', function (e) {
            e.preventDefault();
            closeSidebar();
        }, { passive: false });
    }

    var sidebarNav = document.getElementById('sidebar-nav');
    if (sidebarNav) {
        sidebarNav.addEventListener('click', function (e) {
            var link = e.target.closest ? e.target.closest('a') : null;
            if (link && link.getAttribute('href') && !link.getAttribute('href').startsWith('#')) {
                closeSidebar();
            }
        });
    }
}

function setSidebarReportesOpen(item, open) {
    const toggle = item.querySelector('.sidebar-submenu-toggle');
    const submenu = item.querySelector('.submenu');
    const chevron = item.querySelector('.sidebar-submenu-chevron');
    item.classList.toggle('is-submenu-open', open);
    if (submenu) {
        submenu.classList.toggle('is-open', open);
    }
    if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (chevron) {
        chevron.textContent = open ? '▼' : '▲';
    }
}

function initSidebarReportes() {
    const STORAGE_KEY = 'av-sidebar-reportes-open';

    document.querySelectorAll('[data-sidebar-reportes]').forEach(item => {
        const toggle = item.querySelector('.sidebar-submenu-toggle');
        if (!toggle) {
            return;
        }

        const onReportesPage = item.classList.contains('is-on-reportes-page');
        let stored = null;
        try {
            stored = localStorage.getItem(STORAGE_KEY);
        } catch (e) {
            stored = null;
        }

        let open;
        if (stored === '1') {
            open = true;
        } else if (stored === '0') {
            open = false;
        } else {
            open = onReportesPage;
        }

        setSidebarReportesOpen(item, open);

        toggle.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            const willOpen = !item.classList.contains('is-submenu-open');
            setSidebarReportesOpen(item, willOpen);
            try {
                localStorage.setItem(STORAGE_KEY, willOpen ? '1' : '0');
            } catch (err) {
                /* noop */
            }
        });
    });
}

function initSidebarDesktopCollapse() {
    const toggle = document.getElementById('sidebar-desktop-toggle');
    const layout = document.querySelector('.layout-admin');
    if (!toggle || !layout) {
        return;
    }

    const STORAGE_KEY = 'av-sidebar-desktop-collapsed';
    const mq = window.matchMedia('(min-width: 768px)');

    function setCollapsed(collapsed) {
        layout.classList.toggle('is-sidebar-collapsed', collapsed);
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-label', collapsed ? 'Expandir menú lateral' : 'Contraer menú lateral');
        const icon = toggle.querySelector('.sidebar-desktop-toggle__icon');
        if (icon) {
            icon.textContent = collapsed ? '▶' : '◀';
        }
    }

    function applyStoredState() {
        if (!mq.matches) {
            layout.classList.remove('is-sidebar-collapsed');
            return;
        }
        let stored = null;
        try {
            stored = localStorage.getItem(STORAGE_KEY);
        } catch (e) {
            stored = null;
        }
        setCollapsed(stored === '1');
    }

    toggle.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        if (!mq.matches) {
            return;
        }
        const willCollapse = !layout.classList.contains('is-sidebar-collapsed');
        setCollapsed(willCollapse);
        try {
            localStorage.setItem(STORAGE_KEY, willCollapse ? '1' : '0');
        } catch (err) {
            /* noop */
        }
    });

    mq.addEventListener('change', applyStoredState);
    applyStoredState();
}

// --- Inventario ---
const INVENTARIO_ESTADOS = {
    disponible: { label: 'Disponible', clase: 'inv-estado--disponible' },
    en_reparacion: { label: 'En reparación', clase: 'inv-estado--reparacion' },
    no_disponible: { label: 'No disponible', clase: 'inv-estado--no-disponible' },
};

function celdaInventarioHtml(salonId, tipo, estado) {
    const meta = INVENTARIO_ESTADOS[estado] || { label: estado, clase: '' };
    const tipoLabel = tipo === 'pc' ? 'PC' : 'BEAM';
    return `<button type="button" class="inv-recurso-btn ${meta.clase}" data-salon-id="${salonId}" data-tipo="${tipo}" data-estado="${estado}" title="Clic para cambiar estado de ${tipoLabel}">${tipoLabel}: ${meta.label}</button>`;
}

function actualizarVisibilidadMotivoInv() {
    const sel = document.getElementById('invSelectEstado');
    const wrap = document.getElementById('invMotivoWrap');
    const input = document.getElementById('invMotivo');
    if (!sel || !wrap) return;
    const mostrar = sel.value === 'en_reparacion' || sel.value === 'no_disponible';
    wrap.style.display = mostrar ? 'block' : 'none';
    if (input) {
        if (mostrar) {
            input.setAttribute('required', 'required');
        } else {
            input.removeAttribute('required');
        }
    }
}

function escHtmlInv(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

async function cargarHistorialInventario(bloque) {
    const tbody = document.getElementById('cuerpoHistorialInventario');
    const label = document.getElementById('invHistorialBloqueLabel');
    if (!tbody) return;
    if (label) label.textContent = bloque;
    tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:20px;">Cargando…</td></tr>';
    try {
        const res = await fetch(`api/inventario.php?bloque=${encodeURIComponent(bloque)}&historial=1`);
        const data = await res.json();
        if (!Array.isArray(data)) {
            tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:#c62828;">No se pudo cargar el historial.</td></tr>';
            return;
        }
        if (data.length === 0) {
            tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:#64748b;">Sin cambios registrados en este bloque.</td></tr>';
            return;
        }
        tbody.innerHTML = data.map(row => {
            const fecha = (row.created_at || '').replace('T', ' ').slice(0, 16);
            const cambio = `${row.estado_anterior_etiqueta || '—'} → ${row.estado_nuevo_etiqueta || ''}`;
            const motivo = row.motivo ? escHtmlInv(row.motivo) : '—';
            return `<tr>
                <td>${escHtmlInv(fecha)}</td>
                <td><strong>${escHtmlInv(row.etiqueta_salon || '')}</strong></td>
                <td>${escHtmlInv(row.tipo_etiqueta || '')}</td>
                <td>${escHtmlInv(cambio)}</td>
                <td>${escHtmlInv(row.usuario_nombre || '—')}</td>
                <td>${motivo}</td>
            </tr>`;
        }).join('');
    } catch (e) {
        console.error(e);
        tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:#c62828;">Error de conexión.</td></tr>';
    }
}

async function cargarInventarioBloque(bloque) {
    const tbody = document.getElementById('cuerpoInventario');
    if (!tbody) return;
    tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;padding:24px;">Cargando…</td></tr>';
    cargarHistorialInventario(bloque);
    try {
        const res = await fetch(`api/inventario.php?bloque=${encodeURIComponent(bloque)}`);
        const data = await res.json();
        if (!Array.isArray(data)) {
            tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;color:#c62828;">Error al cargar inventario.</td></tr>';
            return;
        }
        if (data.length === 0) {
            tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;">No hay salones en este bloque.</td></tr>';
            return;
        }
        tbody.innerHTML = '';
        data.forEach(row => {
            tbody.innerHTML += `<tr>
                <td><strong>${row.etiqueta || ''}</strong></td>
                <td>${celdaInventarioHtml(row.salon_id, 'pc', row.pc_estado || 'disponible')}</td>
                <td>${celdaInventarioHtml(row.salon_id, 'beam', row.beam_estado || 'disponible')}</td>
            </tr>`;
        });
        tbody.querySelectorAll('.inv-recurso-btn').forEach(btn => {
            btn.addEventListener('click', () => abrirModalInventarioEstado(btn));
        });
    } catch (e) {
        console.error(e);
        tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;color:#c62828;">Error de conexión.</td></tr>';
    }
}

function abrirModalInventarioEstado(btn) {
    const salonId = btn.getAttribute('data-salon-id');
    const tipo = btn.getAttribute('data-tipo');
    const estado = btn.getAttribute('data-estado') || 'disponible';
    const modal = document.getElementById('modalInventarioEstado');
    if (!modal) return;
    document.getElementById('invSalonId').value = salonId;
    document.getElementById('invTipoRecurso').value = tipo;
    document.getElementById('invSelectEstado').value = estado;
    const motivoEl = document.getElementById('invMotivo');
    if (motivoEl) motivoEl.value = '';
    actualizarVisibilidadMotivoInv();
    const tipoLabel = tipo === 'pc' ? 'PC' : 'BEAM';
    document.getElementById('modalInventarioTitulo').textContent = `Estado — ${tipoLabel}`;
    document.getElementById('modalInventarioSub').textContent = `Salón ID ${salonId}. Elija el estado operativo del equipo.`;
    modal.style.display = 'flex';
}

function initInventario() {
    if (!document.body.dataset.paginaInventario) return;
    const sel = document.getElementById('selectBloqueInventario');
    const bloqueInicial = sel ? sel.value : 'A';
    cargarInventarioBloque(bloqueInicial);
    sel?.addEventListener('change', function () {
        const b = this.value;
        if (b) {
            const url = new URL(window.location.href);
            url.searchParams.set('bloque', b);
            window.history.replaceState({}, '', url);
            cargarInventarioBloque(b);
        }
    });
    document.getElementById('btnCerrarModalInventario')?.addEventListener('click', () => {
        document.getElementById('modalInventarioEstado').style.display = 'none';
    });
    document.getElementById('invSelectEstado')?.addEventListener('change', actualizarVisibilidadMotivoInv);
    document.getElementById('formInventarioEstado')?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(e.target);
        try {
            const res = await fetch('api/inventario.php', { method: 'POST', body: fd });
            const data = await res.json();
            if (!data.success) {
                alert(data.error || 'No se pudo guardar');
                return;
            }
            document.getElementById('modalInventarioEstado').style.display = 'none';
            const bloqueAct = document.getElementById('selectBloqueInventario').value;
            cargarInventarioBloque(bloqueAct);
            cargarHistorialInventario(bloqueAct);
            if (fd.get('estado') === 'no_disponible') {
                alert('Estado guardado. Se notificó a técnicos y administradores.');
            }
        } catch (err) {
            console.error(err);
            alert('Error de conexión');
        }
    });
}

// --- Tema claro / oscuro ---
const THEME_STORAGE_KEY = 'avsystem-theme';

function getSystemTheme() {
    try {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
    } catch (e) {}
    return 'light';
}

function getStoredTheme() {
    try {
        const stored = localStorage.getItem(THEME_STORAGE_KEY);
        if (stored === 'dark' || stored === 'light') {
            return stored;
        }
    } catch (e) {}
    return null;
}

function resolveTheme() {
    return getStoredTheme() || getSystemTheme();
}

function applyTheme(theme) {
    const isDark = theme === 'dark';
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');

    document.querySelectorAll('[data-theme-switch-wrap]').forEach(wrap => {
        wrap.classList.toggle('theme-switch-wrap--dark', isDark);
    });

    document.querySelectorAll('[data-theme-switch]').forEach(btn => {
        btn.setAttribute('aria-checked', isDark ? 'true' : 'false');
        btn.classList.toggle('is-dark', isDark);
    });
}

function setTheme(theme) {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (e) {}
    applyTheme(theme);
}

function toggleTheme() {
    const current = document.documentElement.getAttribute('data-theme') || resolveTheme();
    setTheme(current === 'dark' ? 'light' : 'dark');
}

const PERMISOS_PAGE_SIZE = 10;
const PERMISOS_ROL_LABELS = {
    administrador: 'Administrador',
    tecnico: 'Técnico',
    profesor: 'Profesor',
};

const permisosState = {
    all: [],
    page: 1,
    search: '',
    campo: 'todos',
    rol: '',
};

const permisosModalState = {
    mode: 'usuario',
    usuarioId: null,
    usuarioNombre: '',
    rolKey: null,
    original: [],
    vistas: {},
    reportes: {},
    esAdmin: false,
};

const bloquesSalonesState = {
    bloques: [],
    bloqueSeleccionado: null,
    salones: [],
};

function initBloquesSalones() {
    const lista = document.getElementById('listaBloquesAjustes');
    if (!lista) return;

    document.getElementById('btnCrearBloque')?.addEventListener('click', crearBloqueAjustes);
    document.getElementById('btnCrearSalon')?.addEventListener('click', crearSalonAjustes);
    cargarBloquesAjustes();
}

async function cargarBloquesAjustes() {
    const lista = document.getElementById('listaBloquesAjustes');
    if (!lista) return;
    try {
        const res = await fetch('/api/bloques_salones.php');
        const data = await res.json();
        if (!data.success) throw new Error(data.error || 'Error al cargar bloques.');
        bloquesSalonesState.bloques = data.bloques || [];
        renderBloquesAjustes();
        if (bloquesSalonesState.bloqueSeleccionado) {
            const existe = bloquesSalonesState.bloques.some(b => b.codigo === bloquesSalonesState.bloqueSeleccionado);
            if (!existe) {
                bloquesSalonesState.bloqueSeleccionado = null;
                bloquesSalonesState.salones = [];
                renderSalonesAjustes();
            } else {
                await cargarSalonesBloqueAjustes(bloquesSalonesState.bloqueSeleccionado, false);
            }
        }
    } catch (err) {
        lista.innerHTML = `<p class="texto-secundario" style="color:#b91c1c;">${escapeHtml(err.message)}</p>`;
    }
}

function renderBloquesAjustes() {
    const lista = document.getElementById('listaBloquesAjustes');
    const btnSalon = document.getElementById('btnCrearSalon');
    if (!lista) return;

    if (bloquesSalonesState.bloques.length === 0) {
        lista.innerHTML = '<p class="texto-secundario">No hay bloques. Agregue el primero con el botón superior.</p>';
        if (btnSalon) btnSalon.disabled = true;
        return;
    }

    lista.innerHTML = bloquesSalonesState.bloques.map(b => {
        const activo = b.activo;
        const selected = bloquesSalonesState.bloqueSeleccionado === b.codigo ? ' is-selected' : '';
        return `<div class="bloques-salones-item${selected}" data-bloque="${escapeHtml(b.codigo)}">
            <div class="bloques-salones-item__info">
                <span class="bloques-salones-item__nombre">Bloque ${escapeHtml(b.codigo)}</span>
                <span class="bloques-salones-item__meta">${b.salones_activos}/${b.total_salones} salones activos · ${activo ? 'Activo' : 'Inactivo'}</span>
            </div>
            <div class="bloques-salones-item__acciones">
                <button type="button" class="btn-secundario btn-sm btn-seleccionar-bloque">Ver salones</button>
                <button type="button" class="btn-cancelar btn-sm btn-toggle-bloque">${activo ? 'Inactivar' : 'Activar'}</button>
                <button type="button" class="btn-cancelar btn-sm btn-eliminar-bloque">Eliminar</button>
            </div>
        </div>`;
    }).join('');

    lista.querySelectorAll('.btn-seleccionar-bloque').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.bloques-salones-item');
            seleccionarBloqueAjustes(item?.dataset.bloque || '');
        });
    });
    lista.querySelectorAll('.btn-toggle-bloque').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.bloques-salones-item');
            toggleBloqueAjustes(item?.dataset.bloque || '', btn.textContent.trim() === 'Activar');
        });
    });
    lista.querySelectorAll('.btn-eliminar-bloque').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.bloques-salones-item');
            eliminarBloqueAjustes(item?.dataset.bloque || '');
        });
    });
}

async function seleccionarBloqueAjustes(codigo) {
    bloquesSalonesState.bloqueSeleccionado = codigo;
    renderBloquesAjustes();
    await cargarSalonesBloqueAjustes(codigo, true);
}

async function cargarSalonesBloqueAjustes(codigo, actualizarTitulo) {
    const titulo = document.getElementById('bloqueSalonesTitulo');
    const info = document.getElementById('bloqueSalonesInfo');
    const btnSalon = document.getElementById('btnCrearSalon');
    const lista = document.getElementById('listaSalonesAjustes');
    if (!lista || !codigo) return;

    if (actualizarTitulo && titulo) titulo.textContent = codigo;
    if (info) info.textContent = `Salones del bloque ${codigo}. Etiqueta: ${codigo}-N`;
    if (btnSalon) btnSalon.disabled = false;

    try {
        const res = await fetch(`/api/bloques_salones.php?action=salones&bloque=${encodeURIComponent(codigo)}`);
        const data = await res.json();
        if (!data.success) throw new Error(data.error || 'Error al cargar salones.');
        bloquesSalonesState.salones = data.salones || [];
        renderSalonesAjustes();
    } catch (err) {
        lista.innerHTML = `<p class="texto-secundario" style="color:#b91c1c;">${escapeHtml(err.message)}</p>`;
    }
}

function renderSalonesAjustes() {
    const lista = document.getElementById('listaSalonesAjustes');
    if (!lista) return;

    if (bloquesSalonesState.salones.length === 0) {
        lista.innerHTML = '<p class="texto-secundario">Este bloque no tiene salones. Agregue uno con el botón superior.</p>';
        return;
    }

    lista.innerHTML = bloquesSalonesState.salones.map(s => {
        const activo = s.activo;
        return `<div class="bloques-salones-item" data-salon-id="${s.id}">
            <div class="bloques-salones-item__info">
                <span class="bloques-salones-item__nombre">Salón ${escapeHtml(s.etiqueta)}</span>
                <span class="bloques-salones-item__meta">Piso ${s.piso} · ${activo ? 'Activo' : 'Inactivo'}</span>
            </div>
            <div class="bloques-salones-item__acciones">
                <button type="button" class="btn-cancelar btn-sm btn-toggle-salon">${activo ? 'Inactivar' : 'Activar'}</button>
                <button type="button" class="btn-cancelar btn-sm btn-eliminar-salon">Eliminar</button>
            </div>
        </div>`;
    }).join('');

    lista.querySelectorAll('.btn-toggle-salon').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.bloques-salones-item');
            toggleSalonAjustes(parseInt(item?.dataset.salonId || '0', 10), btn.textContent.trim() === 'Activar');
        });
    });
    lista.querySelectorAll('.btn-eliminar-salon').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.bloques-salones-item');
            eliminarSalonAjustes(parseInt(item?.dataset.salonId || '0', 10), item?.querySelector('.bloques-salones-item__nombre')?.textContent || 'salón');
        });
    });
}

async function postBloquesSalones(action, fields) {
    const fd = new FormData();
    fd.append('action', action);
    Object.entries(fields).forEach(([k, v]) => fd.append(k, String(v)));
    const res = await fetch('/api/bloques_salones.php', { method: 'POST', body: fd });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Operación fallida.');
    return data;
}

async function crearBloqueAjustes() {
    if (!(await avConfirm('¿Agregar un nuevo bloque?\n\nSe asignará la siguiente letra alfabética disponible.'))) return;
    try {
        const data = await postBloquesSalones('crear_bloque', {});
        bloquesSalonesState.bloques = data.bloques || [];
        renderBloquesAjustes();
        if (data.codigo) await seleccionarBloqueAjustes(data.codigo);
    } catch (err) {
        alert(err.message);
    }
}

async function eliminarBloqueAjustes(codigo) {
    if (!codigo) return;
    if (!(await avConfirm(`¿Eliminar el bloque ${codigo} y TODOS sus salones?\n\nSe borrarán horarios e inventario asociados. Las planillas guardadas se conservarán en el Almacén de planillas.`))) return;
    try {
        const data = await postBloquesSalones('eliminar_bloque', { codigo });
        bloquesSalonesState.bloques = data.bloques || [];
        if (bloquesSalonesState.bloqueSeleccionado === codigo) {
            bloquesSalonesState.bloqueSeleccionado = null;
            bloquesSalonesState.salones = [];
            document.getElementById('bloqueSalonesTitulo').textContent = '—';
            document.getElementById('btnCrearSalon').disabled = true;
            document.getElementById('listaSalonesAjustes').innerHTML = '<p class="texto-secundario">Ningún bloque seleccionado.</p>';
        }
        renderBloquesAjustes();
    } catch (err) {
        alert(err.message);
    }
}

async function toggleBloqueAjustes(codigo, activar) {
    if (!codigo) return;
    const msg = activar
        ? `¿Activar el bloque ${codigo} y todos sus salones?`
        : `¿Inactivar el bloque ${codigo}?\n\nTodos sus salones quedarán inactivos y dejarán de mostrarse en los menús de horarios.`;
    if (!(await avConfirm(msg))) return;
    try {
        const data = await postBloquesSalones('toggle_bloque', { codigo, activo: activar ? '1' : '0' });
        bloquesSalonesState.bloques = data.bloques || [];
        renderBloquesAjustes();
        if (bloquesSalonesState.bloqueSeleccionado === codigo) {
            bloquesSalonesState.salones = data.salones || [];
            renderSalonesAjustes();
        }
    } catch (err) {
        alert(err.message);
    }
}

async function crearSalonAjustes() {
    const codigo = bloquesSalonesState.bloqueSeleccionado;
    if (!codigo) return;
    if (!(await avConfirm(`¿Agregar un nuevo salón al bloque ${codigo}?\n\nSe asignará el siguiente número disponible (${codigo}-N).`))) return;
    try {
        const data = await postBloquesSalones('crear_salon', { bloque: codigo });
        bloquesSalonesState.bloques = data.bloques || [];
        bloquesSalonesState.salones = data.salones || [];
        renderBloquesAjustes();
        renderSalonesAjustes();
    } catch (err) {
        alert(err.message);
    }
}

async function toggleSalonAjustes(salonId, activar) {
    const codigo = bloquesSalonesState.bloqueSeleccionado;
    if (!salonId || !codigo) return;
    const salon = bloquesSalonesState.salones.find(s => s.id === salonId);
    const etiqueta = salon?.etiqueta || salonId;
    const msg = activar
        ? `¿Activar el salón ${etiqueta}?`
        : `¿Inactivar el salón ${etiqueta}?\n\nDejará de mostrarse en los menús de planilla y recursos.`;
    if (!(await avConfirm(msg))) return;
    try {
        const data = await postBloquesSalones('toggle_salon', { salon_id: salonId, bloque: codigo, activo: activar ? '1' : '0' });
        bloquesSalonesState.bloques = data.bloques || [];
        bloquesSalonesState.salones = data.salones || [];
        renderBloquesAjustes();
        renderSalonesAjustes();
    } catch (err) {
        alert(err.message);
    }
}

async function eliminarSalonAjustes(salonId, etiqueta) {
    const codigo = bloquesSalonesState.bloqueSeleccionado;
    if (!salonId || !codigo) return;
    if (!(await avConfirm(`¿Eliminar ${etiqueta}?\n\nSe borrarán los horarios actuales e inventario asociados. Las planillas guardadas se conservarán en el Almacén de planillas.`))) return;
    try {
        const data = await postBloquesSalones('eliminar_salon', { salon_id: salonId, bloque: codigo });
        bloquesSalonesState.bloques = data.bloques || [];
        bloquesSalonesState.salones = data.salones || [];
        renderBloquesAjustes();
        renderSalonesAjustes();
    } catch (err) {
        alert(err.message);
    }
}

const ALMACEN_PAGE_SIZE = 10;
const almacenState = {
    tipo: 'profesor',
    planillas: [],
    bloques: [],
    page: 1,
};

function initAlmacenPlanillas() {
    const lista = document.getElementById('listaAlmacenPlanillas');
    if (!lista) return;

    document.getElementById('almacenTipoRol')?.addEventListener('change', () => {
        almacenState.tipo = document.getElementById('almacenTipoRol')?.value || 'profesor';
        actualizarFiltrosAlmacenVisibles();
        cargarAlmacenPlanillas();
    });
    ['almacenBuscar', 'almacenFiltroSalon', 'almacenFiltroCampo', 'almacenFiltroBloqueTec'].forEach(id => {
        const el = document.getElementById(id);
        el?.addEventListener(id === 'almacenBuscar' ? 'input' : 'change', cargarAlmacenPlanillas);
    });

    document.getElementById('almacenFiltroBloque')?.addEventListener('change', async (e) => {
        const bloque = e.target.value;
        await cargarSalonesFiltroAlmacen(bloque);
        cargarAlmacenPlanillas();
    });

    document.getElementById('almacenPagAnterior')?.addEventListener('click', () => {
        if (almacenState.page > 1) {
            almacenState.page -= 1;
            renderAlmacenPlanillas();
        }
    });

    document.getElementById('almacenPagSiguiente')?.addEventListener('click', () => {
        const totalPages = Math.max(1, Math.ceil(almacenState.planillas.length / ALMACEN_PAGE_SIZE));
        if (almacenState.page < totalPages) {
            almacenState.page += 1;
            renderAlmacenPlanillas();
        }
    });

    actualizarFiltrosAlmacenVisibles();
    cargarAlmacenPlanillas();
}

function actualizarFiltrosAlmacenVisibles() {
    const esProf = almacenState.tipo === 'profesor';
    document.querySelectorAll('.almacen-filtro-profesor').forEach(el => { el.style.display = esProf ? '' : 'none'; });
    document.querySelectorAll('.almacen-filtro-tecnico').forEach(el => { el.style.display = esProf ? 'none' : ''; });
    const head = document.getElementById('almacenTablaHead');
    if (head) {
        head.innerHTML = esProf
            ? '<tr><th>Bloque</th><th>Salón</th><th>Semana</th><th>Guardada</th><th>Estado</th><th>Acciones</th></tr>'
            : '<tr><th>Técnico</th><th>Usuario</th><th>Cédula</th><th>Bloques</th><th>Semana</th><th>Guardada</th><th>Acciones</th></tr>';
    }
}

function poblarSelectBloquesAlmacen(bloques) {
    almacenState.bloques = bloques;
    ['almacenFiltroBloque', 'almacenFiltroBloqueTec'].forEach(id => {
        const sel = document.getElementById(id);
        if (!sel) return;
        const val = sel.value;
        sel.innerHTML = '<option value="">Todos</option>' + bloques.map(b => `<option value="${escapeHtml(b)}">${escapeHtml(b)}</option>`).join('');
        sel.value = val;
    });
}

async function cargarSalonesFiltroAlmacen(bloque) {
    const selSalon = document.getElementById('almacenFiltroSalon');
    if (!selSalon) return;
    const oldVal = selSalon.value;
    selSalon.innerHTML = '<option value="">Todos</option>';
    if (bloque) {
        try {
            const res = await fetch(`/api/bloques_salones.php?action=salones&bloque=${encodeURIComponent(bloque)}`);
            const data = await res.json();
            if (data.success && data.salones) {
                data.salones.forEach(s => {
                    selSalon.innerHTML += `<option value="${escapeHtml(s.numero_salon)}">${escapeHtml(s.etiqueta)}</option>`;
                });
            }
        } catch (err) {
            console.error('Error al cargar salones para filtro', err);
        }
    }
    const newOption = Array.from(selSalon.options).find(opt => opt.value === oldVal);
    if (newOption) selSalon.value = oldVal;
}

async function cargarAlmacenPlanillas() {
    const lista = document.getElementById('listaAlmacenPlanillas');
    const info = document.getElementById('almacenResultadosInfo');
    if (!lista) return;

    almacenState.tipo = document.getElementById('almacenTipoRol')?.value || 'profesor';
    const params = new URLSearchParams({ action: 'listar', tipo: almacenState.tipo });
    if (almacenState.tipo === 'profesor') {
        const bloque = document.getElementById('almacenFiltroBloque')?.value || '';
        const salon = document.getElementById('almacenFiltroSalon')?.value?.trim() || '';
        const buscar = document.getElementById('almacenBuscar')?.value?.trim() || '';
        if (bloque) params.set('bloque', bloque);
        if (salon) params.set('salon', salon);
        if (buscar) params.set('buscar', buscar);
    } else {
        const buscar = document.getElementById('almacenBuscar')?.value?.trim() || '';
        const campo = document.getElementById('almacenFiltroCampo')?.value || 'todos';
        const bloque = document.getElementById('almacenFiltroBloqueTec')?.value || '';
        if (buscar) params.set('buscar', buscar);
        if (campo) params.set('campo', campo);
        if (bloque) params.set('bloque', bloque);
    }

    try {
        const res = await fetch(`/api/almacen_planillas.php?${params.toString()}`);
        const data = await res.json();
        if (!data.success) throw new Error(data.error || 'Error al cargar planillas.');
        almacenState.planillas = data.planillas || [];
        almacenState.page = 1;
        if (Array.isArray(data.bloques)) poblarSelectBloquesAlmacen(data.bloques);
        renderAlmacenPlanillas();
    } catch (err) {
        lista.innerHTML = `<tr><td colspan="7" style="text-align:center;padding:20px;color:#b91c1c;">${escapeHtml(err.message)}</td></tr>`;
    }
}

function renderAlmacenPlanillas() {
    const lista = document.getElementById('listaAlmacenPlanillas');
    const pagInfo = document.getElementById('almacenPagInfo');
    const pagAnterior = document.getElementById('almacenPagAnterior');
    const pagSiguiente = document.getElementById('almacenPagSiguiente');
    const info = document.getElementById('almacenResultadosInfo');
    if (!lista) return;
    const cols = almacenState.tipo === 'profesor' ? 6 : 7;

    const totalItems = almacenState.planillas.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / ALMACEN_PAGE_SIZE));

    if (almacenState.page > totalPages) almacenState.page = totalPages;
    
    const pagContenedor = document.getElementById('almacenPaginacion');
    if (pagContenedor) {
        pagContenedor.style.display = totalPages > 1 ? 'flex' : 'none';
    }

    if (totalItems === 0) {
        lista.innerHTML = `<tr><td colspan="${cols}" style="text-align:center;padding:20px;">No hay planillas archivadas con estos filtros.</td></tr>`;
        if (info) info.textContent = '0 planilla(s) encontrada(s)';
        if (pagInfo) pagInfo.textContent = 'Página 1 de 1';
        if (pagAnterior) pagAnterior.disabled = true;
        if (pagSiguiente) pagSiguiente.disabled = true;
        return;
    }

    const start = (almacenState.page - 1) * ALMACEN_PAGE_SIZE;
    const pageItems = almacenState.planillas.slice(start, start + ALMACEN_PAGE_SIZE);
    const desde = start + 1;
    const hasta = start + pageItems.length;

    if (info) info.textContent = `Mostrando ${desde}–${hasta} de ${totalItems} planilla(s) encontrada(s)`;
    if (pagInfo) pagInfo.textContent = `Página ${almacenState.page} de ${totalPages}`;
    if (pagAnterior) pagAnterior.disabled = almacenState.page <= 1;
    if (pagSiguiente) pagSiguiente.disabled = almacenState.page >= totalPages;

    if (almacenState.tipo === 'profesor') {
        lista.innerHTML = pageItems.map(p => {
            const estado = p.salon_vigente ? 'Salón activo' : 'Salón eliminado/inactivo';
            return `<tr>
                <td>${escapeHtml(p.bloque || '—')}</td>
                <td>${escapeHtml(p.etiqueta_salon || '—')}</td>
                <td>${escapeHtml(String(p.semana_inicio || '—'))}</td>
                <td>${escapeHtml(String(p.created_at || '—'))}</td>
                <td>${escapeHtml(estado)}</td>
                <td>
                    <button type="button" class="btn-secundario btn-sm btn-almacen-imprimir" data-id="${p.id}" data-tipo="profesor">Imprimir</button>
                    <button type="button" class="btn-cancelar btn-sm btn-almacen-eliminar" data-id="${p.id}" data-tipo="profesor">Eliminar</button>
                </td>
            </tr>`;
        }).join('');
    } else {
        lista.innerHTML = pageItems.map(p => `<tr>
            <td>${escapeHtml(p.nombre || '—')}</td>
            <td>${escapeHtml(p.usuario || '—')}</td>
            <td>${escapeHtml(p.cedula != null ? String(p.cedula) : '—')}</td>
            <td>${escapeHtml(p.bloques || '—')}</td>
            <td>${escapeHtml(String(p.semana_inicio || '—'))}</td>
            <td>${escapeHtml(String(p.created_at || '—'))}</td>
            <td>
                <button type="button" class="btn-secundario btn-sm btn-almacen-imprimir" data-id="${p.id}" data-tipo="tecnico">Imprimir</button>
                <button type="button" class="btn-cancelar btn-sm btn-almacen-eliminar" data-id="${p.id}" data-tipo="tecnico">Eliminar</button>
            </td>
        </tr>`).join('');
    }

    lista.querySelectorAll('.btn-almacen-imprimir').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.id;
            const tipo = btn.dataset.tipo || 'profesor';
            window.open(`/planilla_archivo_imprimir.php?tipo=${encodeURIComponent(tipo)}&id=${encodeURIComponent(id)}`, '_blank');
        });
    });
    lista.querySelectorAll('.btn-almacen-eliminar').forEach(btn => {
        btn.addEventListener('click', () => eliminarAlmacenPlanilla(parseInt(btn.dataset.id, 10), btn.dataset.tipo || 'profesor'));
    });
}

async function eliminarAlmacenPlanilla(id, tipo) {
    if (!(await avConfirm('¿Eliminar esta planilla archivada? No se puede deshacer.'))) return;
    const fd = new FormData();
    fd.append('action', 'eliminar');
    fd.append('id', String(id));
    fd.append('tipo', tipo);
    try {
        const res = await fetch('/api/almacen_planillas.php', { method: 'POST', body: fd });
        const data = await res.json();
        if (!data.success) throw new Error(data.error || 'No se pudo eliminar.');
        cargarAlmacenPlanillas();
    } catch (err) {
        alert(err.message);
    }
}

function initAjustes() {
    if (!document.getElementById('toggleLimpiezaSemanal') && !document.getElementById('listaBloquesAjustes')) return;

    initToggleLimpiezaSemanal();
    initToggleEsp32Validacion();
    initToggleTecnicoAccesoEstricto();
    initBloquesSalones();
    initAlmacenPlanillas();

    const lista = document.getElementById('listaPermisosUsuarios');
    if (!lista) return;

    cargarPermisosUsuarios();

    const buscar = document.getElementById('permisosBuscar');
    const filtroCampo = document.getElementById('permisosFiltroCampo');
    const filtroRol = document.getElementById('permisosFiltroRol');
    const pagAnterior = document.getElementById('permisosPagAnterior');
    const pagSiguiente = document.getElementById('permisosPagSiguiente');

    const onFiltroChange = () => {
        permisosState.search = (buscar?.value || '').trim().toLowerCase();
        permisosState.campo = filtroCampo?.value || 'todos';
        permisosState.rol = filtroRol?.value || '';
        permisosState.page = 1;
        renderPermisosFiltrados();
    };

    buscar?.addEventListener('input', onFiltroChange);
    filtroCampo?.addEventListener('change', onFiltroChange);
    filtroRol?.addEventListener('change', onFiltroChange);

    pagAnterior?.addEventListener('click', () => {
        if (permisosState.page > 1) {
            permisosState.page -= 1;
            renderPermisosFiltrados();
        }
    });

    pagSiguiente?.addEventListener('click', () => {
        const totalPages = getPermisosTotalPages();
        if (permisosState.page < totalPages) {
            permisosState.page += 1;
            renderPermisosFiltrados();
        }
    });

    document.querySelectorAll('.btn-permisos-rol').forEach(btn => {
        btn.addEventListener('click', () => {
            abrirModalPermisosRol(btn.dataset.rol || '');
        });
    });

    document.getElementById('btnCancelarPermisos')?.addEventListener('click', cerrarModalPermisos);
    document.getElementById('formPermisos')?.addEventListener('submit', guardarPermisos);

    const modal = document.getElementById('modalPermisos');
    if (modal) {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                cerrarModalPermisos();
            }
        });
    }
}

function initToggleLimpiezaSemanal() {
    const toggle = document.getElementById('toggleLimpiezaSemanal');
    const badge = document.getElementById('estadoLimpiezaSemanal');
    if (!toggle) return;

    toggle.addEventListener('change', async () => {
        const enabled = toggle.checked;
        if (!enabled) {
            const ok = await avConfirm(
                '¿Desactivar la limpieza semanal automática?', 
                'Se guardará un respaldo de las planillas actuales y dejarán de vaciarse cada semana.'
            );
            if (!ok) {
                toggle.checked = true;
                return;
            }
        }

        const fd = new FormData();
        fd.append('limpieza_semanal', enabled ? '1' : '0');

        try {
            const res = await fetch('/api/ajustes.php', { method: 'POST', body: fd });
            const data = await res.json();
            if (!data.success) {
                throw new Error(data.error || 'No se pudo guardar la configuración.');
            }
            if (badge) {
                badge.textContent = enabled ? 'Activada' : 'Desactivada';
                badge.classList.toggle('is-on', enabled);
                badge.classList.toggle('is-off', !enabled);
            }
        } catch (err) {
            toggle.checked = !enabled;
            alert(err.message || 'Error al guardar.');
        }
    });
}

function initToggleEsp32Validacion() {
    const toggle = document.getElementById('toggleEsp32Validacion');
    const badge  = document.getElementById('estadoEsp32Validacion');
    if (!toggle) return;

    toggle.addEventListener('change', async () => {
        const enabled = toggle.checked;
        if (!enabled) {
            const ok = await avConfirm(
                '¿Desactivar la validación de horario del lector ESP32?',
                'En modo libre, cualquier profesor podrá marcar asistencia en cualquier momento.\n' +
                'Se registrará el bloque horario más próximo.\n\n' +
                '⚠ Solo usar para pruebas. Recuerda reactivar antes de poner en producción.'
            );
            if (!ok) {
                toggle.checked = true;
                return;
            }
        }

        const fd = new FormData();
        fd.append('esp32_validacion_horario', enabled ? '1' : '0');

        try {
            const res = await fetch('/api/ajustes.php', { method: 'POST', body: fd });
            const data = await res.json();
            if (!data.success) {
                throw new Error(data.error || 'No se pudo guardar la configuración.');
            }
            if (badge) {
                badge.textContent = enabled ? 'Activada' : 'Desactivada';
                badge.classList.toggle('is-on', enabled);
                badge.classList.toggle('is-off', !enabled);
            }
        } catch (err) {
            toggle.checked = !enabled;
            alert(err.message || 'Error al guardar.');
        }
    });
}

function initToggleTecnicoAccesoEstricto() {
    const toggle = document.getElementById('toggleTecnicoAccesoEstricto');
    const badge  = document.getElementById('estadoTecnicoAccesoEstricto');
    if (!toggle) return;

    toggle.addEventListener('change', async () => {
        const enabled = toggle.checked;
        const fd = new FormData();
        fd.append('tecnico_acceso_estricto', enabled ? '1' : '0');

        try {
            const res = await fetch('/api/ajustes.php', { method: 'POST', body: fd });
            const data = await res.json();
            if (!data.success) {
                throw new Error(data.error || 'No se pudo guardar la configuración.');
            }
            if (badge) {
                badge.textContent = enabled ? 'Activado' : 'Desactivado';
                badge.classList.toggle('is-on', enabled);
                badge.classList.toggle('is-off', !enabled);
            }
        } catch (err) {
            toggle.checked = !enabled;
            alert(err.message || 'Error al guardar.');
        }
    });
}

async function cargarPermisosUsuarios() {
    const lista = document.getElementById('listaPermisosUsuarios');
    if (!lista) return;

    try {
        const res = await fetch('/api/permisos_usuario.php?action=listar');
        const data = await res.json();
        if (!Array.isArray(data)) {
            throw new Error('Respuesta inválida del servidor.');
        }
        permisosState.all = data;
        permisosState.page = 1;
        renderPermisosFiltrados();
    } catch (err) {
        lista.innerHTML = `<tr><td colspan="4" style="text-align:center;padding:20px;color:#b91c1c;">${escapeHtml(err.message || 'Error al cargar usuarios.')}</td></tr>`;
    }
}

function getPermisosFiltrados() {
    return permisosState.all.filter(permisoUsuarioMatchesFilter);
}

function getPermisosTotalPages() {
    return Math.max(1, Math.ceil(getPermisosFiltrados().length / PERMISOS_PAGE_SIZE));
}

function permisoUsuarioMatchesFilter(u) {
    if (permisosState.rol && u.rol !== permisosState.rol) {
        return false;
    }

    const term = permisosState.search;
    if (!term) {
        return true;
    }

    const campo = permisosState.campo;
    const usuario = String(u.usuario || '').toLowerCase();
    const cedula = String(u.cedula ?? '').toLowerCase();

    if (campo === 'usuario') {
        return usuario.includes(term);
    }
    if (campo === 'cedula') {
        return cedula.includes(term);
    }

    return usuario.includes(term) || cedula.includes(term);
}

function renderPermisosFiltrados() {
    const lista = document.getElementById('listaPermisosUsuarios');
    const info = document.getElementById('permisosResultadosInfo');
    const pagInfo = document.getElementById('permisosPagInfo');
    const pagAnterior = document.getElementById('permisosPagAnterior');
    const pagSiguiente = document.getElementById('permisosPagSiguiente');
    if (!lista) return;

    const filtrados = getPermisosFiltrados();
    const totalPages = getPermisosTotalPages();
    if (permisosState.page > totalPages) {
        permisosState.page = totalPages;
    }

    if (permisosState.all.length === 0) {
        lista.innerHTML = '<tr><td colspan="4" style="text-align:center;padding:20px;">No hay usuarios registrados.</td></tr>';
        if (info) info.textContent = '0 usuarios';
        if (pagInfo) pagInfo.textContent = 'Página 1 de 1';
        if (pagAnterior) pagAnterior.disabled = true;
        if (pagSiguiente) pagSiguiente.disabled = true;
        return;
    }

    if (filtrados.length === 0) {
        lista.innerHTML = '<tr><td colspan="4" style="text-align:center;padding:20px;">Ningún usuario coincide con la búsqueda.</td></tr>';
        if (info) info.textContent = `0 de ${permisosState.all.length} usuarios`;
        if (pagInfo) pagInfo.textContent = 'Página 1 de 1';
        if (pagAnterior) pagAnterior.disabled = true;
        if (pagSiguiente) pagSiguiente.disabled = true;
        return;
    }

    const start = (permisosState.page - 1) * PERMISOS_PAGE_SIZE;
    const pageItems = filtrados.slice(start, start + PERMISOS_PAGE_SIZE);
    const desde = start + 1;
    const hasta = start + pageItems.length;

    if (info) {
        info.textContent = `Mostrando ${desde}–${hasta} de ${filtrados.length} (${permisosState.all.length} en total)`;
    }
    if (pagInfo) {
        pagInfo.textContent = `Página ${permisosState.page} de ${totalPages}`;
    }
    if (pagAnterior) {
        pagAnterior.disabled = permisosState.page <= 1;
    }
    if (pagSiguiente) {
        pagSiguiente.disabled = permisosState.page >= totalPages;
    }

    lista.innerHTML = pageItems.map(u => {
        const rolLabel = PERMISOS_ROL_LABELS[u.rol] || u.rol || '—';
        const cedula = u.cedula != null && u.cedula !== '' ? escapeHtml(String(u.cedula)) : '—';
        const badgePersonalizado = u.tiene_personalizado && u.rol !== 'administrador'
            ? '<span class="permisos-badge-personalizado" title="Permisos individuales">Personalizado</span>'
            : '';
        return `<tr>
            <td>${escapeHtml(u.usuario || '—')}${badgePersonalizado}</td>
            <td>${cedula}</td>
            <td>${escapeHtml(rolLabel)}</td>
            <td><button type="button" class="btn-secundario btn-permisos-usuario" data-id="${u.id}" data-usuario="${escapeHtml(u.usuario || '')}">Permisos</button></td>
        </tr>`;
    }).join('');

    lista.querySelectorAll('.btn-permisos-usuario').forEach(btn => {
        btn.addEventListener('click', () => {
            abrirModalPermisos(parseInt(btn.dataset.id, 10), btn.dataset.usuario || '');
        });
    });
}

async function abrirModalPermisos(usuarioId, usuarioNombre) {
    const modal = document.getElementById('modalPermisos');
    const titulo = document.getElementById('modalPermisosTitulo');
    const sub = document.getElementById('modalPermisosSub');
    const avisoAdmin = document.getElementById('modalPermisosAdminAviso');
    const checkboxes = document.getElementById('permisosCheckboxes');
    const form = document.getElementById('formPermisos');
    const btnGuardar = document.getElementById('btnGuardarPermisos');
    if (!modal || !checkboxes) return;

    try {
        const res = await fetch(`/api/permisos_usuario.php?usuario_id=${usuarioId}`);
        const data = await res.json();
        if (!data.success) {
            throw new Error(data.error || 'No se pudieron cargar los permisos.');
        }

        permisosModalState.mode = 'usuario';
        permisosModalState.usuarioId = usuarioId;
        permisosModalState.usuarioNombre = usuarioNombre;
        permisosModalState.rolKey = data.rol || null;
        permisosModalState.original = [...(data.permisos || [])].sort();
        permisosModalState.vistas = data.vistas || {};
        permisosModalState.reportes = data.reportes || {};
        permisosModalState.esAdmin = !!data.es_admin;

        document.getElementById('permisosModo').value = 'usuario';
        document.getElementById('permisosUsuarioId').value = String(usuarioId);
        document.getElementById('permisosRolKey').value = '';
        if (titulo) titulo.textContent = `Permisos — ${usuarioNombre || 'Usuario'}`;
        const rolLabel = PERMISOS_ROL_LABELS[data.rol] || data.rol || '—';
        if (sub) {
            sub.textContent = data.es_admin
                ? `Rol: ${rolLabel}`
                : data.hereda_rol
                    ? `Rol: ${rolLabel} · Hereda permisos generales del rol`
                    : `Rol: ${rolLabel} · Permisos personalizados (sobreescriben el rol)`;
        }

        renderPermisosCheckboxes(data.permisos || [], data.es_admin);
        mostrarModalPermisos(data.es_admin, form, btnGuardar, avisoAdmin);
    } catch (err) {
        alert(err.message || 'Error al abrir permisos.');
    }
}

async function abrirModalPermisosRol(rol) {
    const modal = document.getElementById('modalPermisos');
    const titulo = document.getElementById('modalPermisosTitulo');
    const sub = document.getElementById('modalPermisosSub');
    const avisoAdmin = document.getElementById('modalPermisosAdminAviso');
    const checkboxes = document.getElementById('permisosCheckboxes');
    const form = document.getElementById('formPermisos');
    const btnGuardar = document.getElementById('btnGuardarPermisos');
    if (!modal || !checkboxes || !rol) return;

    try {
        const res = await fetch(`/api/permisos_rol.php?rol=${encodeURIComponent(rol)}`);
        const data = await res.json();
        if (!data.success) {
            throw new Error(data.error || 'No se pudieron cargar los permisos del rol.');
        }

        const rolLabel = PERMISOS_ROL_LABELS[rol] || rol;
        permisosModalState.mode = 'rol';
        permisosModalState.usuarioId = null;
        permisosModalState.usuarioNombre = rolLabel;
        permisosModalState.rolKey = rol;
        permisosModalState.original = [...(data.permisos || [])].sort();
        permisosModalState.vistas = data.vistas || {};
        permisosModalState.reportes = data.reportes || {};
        permisosModalState.esAdmin = false;

        document.getElementById('permisosModo').value = 'rol';
        document.getElementById('permisosUsuarioId').value = '';
        document.getElementById('permisosRolKey').value = rol;
        if (titulo) titulo.textContent = `Permisos del rol — ${rolLabel}`;
        if (sub) {
            sub.textContent = data.tiene_personalizado
                ? 'Permisos personalizados del rol. Afecta a todos los usuarios que no tengan configuración individual.'
                : 'Permisos predeterminados del rol. Afecta a todos los usuarios que no tengan configuración individual.';
        }

        renderPermisosCheckboxes(data.permisos || [], false);
        mostrarModalPermisos(false, form, btnGuardar, avisoAdmin);
    } catch (err) {
        alert(err.message || 'Error al abrir permisos del rol.');
    }
}

function mostrarModalPermisos(esAdmin, form, btnGuardar, avisoAdmin) {
    const modal = document.getElementById('modalPermisos');
    if (avisoAdmin) {
        avisoAdmin.style.display = esAdmin ? 'block' : 'none';
    }
    if (form) {
        form.style.display = esAdmin ? 'none' : 'block';
    }
    if (btnGuardar) {
        btnGuardar.style.display = esAdmin ? 'none' : '';
    }
    if (modal) {
        modal.style.display = 'flex';
    }
}

function renderPermisosCheckboxes(permisosActivos, esAdmin) {
    const container = document.getElementById('permisosCheckboxes');
    if (!container) return;

    const activos = new Set(permisosActivos);
    const grupos = {};

    Object.entries(permisosModalState.vistas).forEach(([key, meta]) => {
        const group = meta.group || 'General';
        if (!grupos[group]) {
            grupos[group] = [];
        }
        grupos[group].push({ key, label: meta.label });
    });

    let html = '';
    Object.keys(grupos).sort().forEach(groupName => {
        html += `<div class="permisos-grupo"><p class="permisos-grupo__titulo">${escapeHtml(groupName)}</p>`;
        grupos[groupName].forEach(({ key, label }) => {
            const checked = activos.has(key) ? 'checked' : '';
            const disabled = esAdmin ? 'disabled' : '';
            html += `<label class="permiso-check">
                <input type="checkbox" name="permisos[]" value="${escapeHtml(key)}" data-perm-vista ${checked} ${disabled}>
                <span>${escapeHtml(label)}</span>
            </label>`;

            if (key === 'vista.reportes') {
                const subsVisible = activos.has('vista.reportes') ? '' : 'style="display:none;"';
                html += `<div class="permisos-reportes-sub" data-reportes-sub ${subsVisible}>`;
                Object.entries(permisosModalState.reportes).forEach(([rKey, rLabel]) => {
                    const rChecked = activos.has(rKey) ? 'checked' : '';
                    html += `<label class="permiso-check permiso-check--sub">
                        <input type="checkbox" name="permisos[]" value="${escapeHtml(rKey)}" data-perm-reporte ${rChecked} ${disabled}>
                        <span>${escapeHtml(rLabel)}</span>
                    </label>`;
                });
                html += '</div>';
            }
        });
        html += '</div>';
    });

    container.innerHTML = html;

    const reportesVista = container.querySelector('input[value="vista.reportes"]');
    const subsBlock = container.querySelector('[data-reportes-sub]');
    reportesVista?.addEventListener('change', () => {
        if (!subsBlock) return;
        subsBlock.style.display = reportesVista.checked ? '' : 'none';
        if (!reportesVista.checked) {
            subsBlock.querySelectorAll('input[data-perm-reporte]').forEach(cb => {
                cb.checked = false;
            });
        }
    });
}

function collectPermisosFromForm() {
    const container = document.getElementById('permisosCheckboxes');
    if (!container) return [];
    return Array.from(container.querySelectorAll('input[name="permisos[]"]:checked')).map(cb => cb.value);
}

function permisosArraysEqual(a, b) {
    if (a.length !== b.length) return false;
    const sa = [...a].sort();
    const sb = [...b].sort();
    return sa.every((v, i) => v === sb[i]);
}

function validarPermisosCliente(permisos) {
    const tieneReportes = permisos.includes('vista.reportes');
    const subs = permisos.filter(p => p.startsWith('reporte.pag'));
    if (tieneReportes && subs.length === 0) {
        return 'Si concede acceso a Reportes, debe seleccionar al menos una subvista.';
    }
    if (!tieneReportes && subs.length > 0) {
        return 'Las subvistas de reportes requieren acceso al índice de Reportes.';
    }
    return '';
}

function cerrarModalPermisos() {
    const modal = document.getElementById('modalPermisos');
    if (modal) {
        modal.style.display = 'none';
    }
    permisosModalState.mode = 'usuario';
    permisosModalState.usuarioId = null;
    permisosModalState.rolKey = null;
    permisosModalState.original = [];
}

async function guardarPermisos(e) {
    e.preventDefault();
    if (permisosModalState.esAdmin) return;

    const permisos = collectPermisosFromForm();
    const error = validarPermisosCliente(permisos);
    if (error) {
        alert(error);
        return;
    }

    if (permisosArraysEqual(permisos, permisosModalState.original)) {
        cerrarModalPermisos();
        return;
    }

    const esRol = permisosModalState.mode === 'rol';
    const ok = await avConfirm(
        esRol
            ? `¿Está seguro de guardar los permisos generales del rol "${permisosModalState.usuarioNombre}"?`
            : `¿Está seguro de guardar los cambios de permisos para "${permisosModalState.usuarioNombre}"?`,
        esRol
            ? `Afectará a todos los usuarios de ese rol sin configuración individual.`
            : `Los permisos individuales tienen prioridad sobre los del rol.`
    );
    if (!ok) return;

    const fd = new FormData();
    permisos.forEach(p => fd.append('permisos[]', p));

    try {
        let res;
        if (esRol) {
            fd.append('rol', permisosModalState.rolKey || '');
            res = await fetch('/api/permisos_rol.php', { method: 'POST', body: fd });
        } else {
            fd.append('usuario_id', String(permisosModalState.usuarioId));
            res = await fetch('/api/permisos_usuario.php', { method: 'POST', body: fd });
        }
        const data = await res.json();
        if (!data.success) {
            throw new Error(data.error || 'No se pudieron guardar los permisos.');
        }
        cerrarModalPermisos();
        if (!esRol) {
            cargarPermisosUsuarios();
        }
    } catch (err) {
        alert(err.message || 'Error al guardar permisos.');
    }
}

function initThemeSwitcher() {
    const current = document.documentElement.getAttribute('data-theme');
    if (current !== 'dark' && current !== 'light') {
        applyTheme(resolveTheme());
    } else {
        applyTheme(current);
    }

    document.querySelectorAll('[data-theme-switch]').forEach(btn => {
        if (btn.dataset.themeBound === '1') {
            return;
        }
        btn.dataset.themeBound = '1';
        btn.addEventListener('click', e => {
            e.preventDefault();
            toggleTheme();
        });
    });
}

// Ejecutar al cargar el DOM
document.addEventListener('DOMContentLoaded', () => {
    initThemeSwitcher();
    initSidebarMobile();
    initSidebarDesktopCollapse();
    initSidebarReportes();
    initUsuarios();
    initAjustes();
    initMantenimiento();
    initInventario();

    // Cerrar modales al hacer clic fuera del contenido
    document.querySelectorAll('.modal-overlay').forEach(modal => {
        modal.addEventListener('click', function(e) {
            if (e.target === this) {
                this.style.display = 'none';
            }
        });
    });
});